import { useMutation } from '@tanstack/react-query';
import { resendVerification } from '../api/emailVerifyApi';

/** Мутация повторной отправки письма подтверждения. Без инвалидации кэша —
 *  статус подтверждения меняется только после перехода по ссылке из письма. */
export function useResendVerification() {
  return useMutation({ mutationFn: resendVerification });
}
